import { render, staticRenderFns } from "./AddPricesCSVView.vue?vue&type=template&id=4f3fe56f&"
import script from "./AddPricesCSVView.vue?vue&type=script&lang=js&"
export * from "./AddPricesCSVView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports